<script>
import { NavBar } from "vant";

export default {
  name: "HeadNavBar",
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    leftArrow: {
      type: Boolean,
      default: true,
    },
    rightText: {
      type: String,
      default: "",
    },
  },
  methods: {
    onLeftClick() {
      if (this.$listeners["click-left"]) {
        this.$emit("click-left");
      } else {
        this.$router.go(-1);
      }
    },
    onRightClick() {
      if (this.$listeners["click-right"]) {
        this.$emit("click-right");
      }
    },
  },
  render() {
    const option = {
      props: {
        title: this.title,
        fixed: this.fixed,
        leftArrow: this.leftArrow,
      },
      on: {
        "click-left": this.onLeftClick,
        "click-right": this.onRightClick,
      },
    };
    if (this.rightText) {
      option.props.rightText = this.rightText;
    }
    const slots = Object.keys(this.$slots).map(name => (
      <template slot={name}>{this.$slots[name]}</template>
    ));
    return <van-nav-bar {...option}>{slots}</van-nav-bar>;
  },
};
</script>

<style lang="less" scoped></style>
